import styled from 'styled-components';

export const UserOptionsContent = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    gap: 0.5rem;

    section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
    }

    p {
        color: var(--Neutral-100, #f4f4f5);
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.5rem;
    }

    span {
        color: var(--Neutral-100, #f4f4f5);
        font-size: 1rem;
        font-weight: 400;
        line-height: 1rem;
    }

    border: none;
    background: none;
    cursor: pointer;
`;

export const UserOptionsFloatingContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.5rem 0.5rem;
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 0.75rem;
    box-shadow: 0px 0px 2px 2px rgb(0, 0, 0, 0.1);
    gap: 0.25rem;

    button {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        border: none;
        background: none;
        cursor: pointer;
        border-radius: 0.75rem;
        padding: 0.5rem 0.75rem;
        transition: 0.05s;
        color: #09090b;

        p {
            font-size: 1rem;
            font-weight: 500;
        }

        svg {
            width: 1.25rem;
            height: 1.25rem;
            color: #09090b;
        }

        &:hover {
            background: var(--Supernova-500, #ffcf00);
            color: var(--Supernova-950, #442404);
        }
    }
`;
